import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Labels, SdfCardLabels } from '../app.models';

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss'],
})
export class MoreInfoComponent {
  @Output() public next: EventEmitter<any> = new EventEmitter<any>();
  sdfCardLabels: SdfCardLabels;

  private _labels: any;
  @Input() public set labels(labels: Labels) {
    this.sdfCardLabels = labels.stellar.sdfcard;
  }
  public get labels() {
    return this._labels;
  }

  constructor() {}

  public nextPage() {
    this.next.emit(2);
  }
}
